import React from "react";
import styled from "@emotion/styled";
// utils
import { Color } from "../../utils/color";

export const FavoriteBtn = () => {
  const onClickFavorite = () => {
    alert("お気に入りに追加しました。このサイトはデモサイトです。");
  };
  return (
    <SBtn onClick={onClickFavorite}>
      <i className="material-icons-outlined">star_border</i>
      <span>お気に入りに追加する</span>
    </SBtn>
  );
};

const SBtn = styled.button`
  height: 64px;
  width: 100%;
  border-radius: 8px;
  border: 1px solid ${Color.gray200};
  background-color: ${Color.white};
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 0.9rem;
    font-weight: 500;
    line-height: 1;
    margin-left: 0.5rem;
  }
  i,
  span {
    color: ${Color.gray400};
    transition: all 0.2s;
  }
  @media screen and (min-width: 1024px) {
    &:hover {
      border-color: ${Color.gray200};
      background-color: ${Color.white};
      i,
      span {
        color: ${Color.gray400};
      }
    }
  }
  @media screen and (max-width: 1023px) {
    &:active {
      border-color: ${Color.gray200};
      background-color: ${Color.white};
      i,
      span {
        color: ${Color.gray400};
      }
    }
  }
`;
